import { Route, Routes } from 'react-router-dom';
import './App.css';
import About from './Component/About/About';
import Footer from './Component/Footer/Footer';
import Videos from './Component/LoadVIdeos/Video';
import Playlist from './Component/Playlist/Playlist';
import { SearchVideos } from './Component/SearchVideos/SearchVideos';
import Header from './Header/Header';
import Hero from './Hero/Hero';
import WriteBlog from './Hero/WriteBlog/WriteBlog';

function App() {

  return (
    <div className="bg-white">
      <Header></Header>
      <Routes>
        <Route path="/" element={<Hero></Hero>}></Route>
        <Route path="/about" element={<About></About>}></Route>
        <Route path="/videos" element={<Videos></Videos>}></Route>
        <Route path="/playlist" element={<Playlist></Playlist>}></Route>
        <Route path="/writeBlog" element={<WriteBlog></WriteBlog>}></Route>
        <Route path="/searchVideo" element={<SearchVideos></SearchVideos>}>
          <Route path=':video' element={<SearchVideos></SearchVideos>}></Route>
        </Route>
      </Routes>
      <Footer></Footer>
    </div>
  );
}

export default App;
